export default {
  bot: 'Bot',
  agent: 'Atendente',
  status: 'Status',
  ticketsCount: 'Tickets em atendimento',
  averageResponseTime: 'Tempo médio de resposta',
  averageAttendanceTime: 'Tempo de atendimento',
};
